import { render } from "./InstanceLogs.vue?vue&type=template&id=6b791a27&scoped=true"
import script from "./InstanceLogs.vue?vue&type=script&lang=js"
export * from "./InstanceLogs.vue?vue&type=script&lang=js"

import "./InstanceLogs.vue?vue&type=style&index=0&id=6b791a27&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b791a27"]])

export default __exports__